'use client';

import { ComponentProps } from 'react';
import { User } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/shared/components/primitives/link';
import { logoutUser } from '@/features/auth/shared/helpers/browser-clients/session';
import { DropdownMenu } from '@/shared/components/primitives/dropdown-menu';
import { accountOptions } from '@/shared/constants/routes';

export const AccountOptions = () => {
  const t = useTranslations('Home.header.accountOptions');

  const linkClassName = 'block w-full py-3 pl-4';

  const translatedAuthenticatedAccountOptions: ComponentProps<typeof DropdownMenu>['items'] =
    accountOptions.map((option) => ({
      label: (
        <Link href={option.href} className={linkClassName}>
          {t(option.labelKey)}
        </Link>
      ),
      value: option.href,
    }));

  translatedAuthenticatedAccountOptions.push({
    label: <span className={linkClassName}>{t('logout')}</span>,
    value: '',
    onClick: () => logoutUser(),
  });

  return (
    <DropdownMenu
      menuIcon={
        <User size={20} fill='currentColor' aria-hidden='true' className='-translate-y-0.5' />
      }
      menuIconPosition='start'
      menuTitle={t('myAccount')}
      items={translatedAuthenticatedAccountOptions}
      ariaLabel={t('userAccountOptions')}
      triggerClassName='ml-0 gap-1 max-lg:-mt-8 max-lg:self-start'
      align='start'
      className='px-1'
      itemClassName='p-0'
      withArrow
    />
  );
};
